<script setup lang="ts">
import { NxtModal, NxtWarningMessage } from '@nxtpeople/nxt-styles';
import { ref } from 'vue';
import { useStore } from 'vuex';

const { dispatch } = useStore();

const props = defineProps({
   title: { type: String, default: '' },
   description: { type: String, default: '' },
   confirmText: { type: String, default: null },
   cancelText: { type: String, default: null },
   onConfirm: { type: Function, default: null },
   onCancel: { type: Function, default: null },
   warningMessage: { type: Object, default: null },
});

const loading = ref(false);

function handleCancel() {
   dispatch('modal/closeConfirmation');
   if (props.onCancel) props.onCancel();
}

function handleConfirm() {
   loading.value = true;
   if (props.onConfirm) {
      props.onConfirm(() => {
         loading.value = false;
         dispatch('modal/closeConfirmation');
      });
   }
}
</script>

<template>
   <NxtModal
      :title="title"
      :cancel-text="cancelText || $t('actions.cancel')"
      :primary-action-text="confirmText || $t('actions.confirm')"
      :loading="loading"
      @on-cancel="handleCancel"
      @on-primary-action="handleConfirm"
   >
      <p v-if="description" class="confirmation-modal__description">{{ description }}</p>

      <NxtWarningMessage v-if="warningMessage" :type="'danger'"> {{ warningMessage?.text }} </NxtWarningMessage>
   </NxtModal>
</template>

<style lang="scss" scoped>
.confirmation-modal__description {
   line-height: 1.2rem;
}
</style>
